//
//
//
//

import { mapGetters } from 'vuex'
export default {
  name: 'DetailChart',
  computed: {
    ...mapGetters({
      chartData: 'coins/chartData'
    })
  },
  mounted () {
    if (this.chartData && this.chartData.length) {
      const { LightWeightCharts } = this.$lwcCore()

      const width = 600
      const height = 300

      const chart = LightWeightCharts.createChart(this.$refs.chartjs, {
        rightPriceScale: {
          scaleMargins: {
            top: 0.2,
            bottom: 0.2
          },
          borderVisible: false
        },
        timeScale: {
          borderVisible: false,
          secondsVisible: false,
          timeVisible: true,
          fixLeftEdge: true,
          fixRightEdge: true

        },
        layout: {
          backgroundColor: '#ffffff',
          textColor: '#333'
        },
        grid: {
          horzLines: {
            color: '#eee'
          },
          vertLines: {
            color: '#ffffff'
          }
        },
        crosshair: {
          vertLine: {
            labelVisible: false
          }
        }
      })

      chart.resize(width, height)

      const series = chart.addAreaSeries({
        topColor: 'rgba(0, 150, 136, 0.56)',
        bottomColor: 'rgba(0, 150, 136, 0.04)',
        lineColor: 'rgba(0, 150, 136, 1)',
        lineWidth: 2
      })
      // eslint-disable-next-line no-return-assign
      series.setData(this.chartData.map(i => i = { time: i.time, value: i.priceUsd }))
      new ResizeObserver((entries) => {
        if (entries.length === 0 || entries[0].target !== this.$refs.chartjs) { return }
        const newRect = entries[0].contentRect
        chart.applyOptions({ height: newRect.height, width: newRect.width })
      }).observe(this.$refs.chartjs)

      function checkDecimal (value) {
        switch (true) {
          case (value === 0):
            return 0

          case (value < 0.0001):
            return 8

          case (value < 1):
            return 6

          case (value <= 1000):
            return 2

          case (value > 1000):
            return 0
        }
      }

      series.applyOptions({
        priceFormat: {
          type: 'price',
          precision: checkDecimal(+this.chartData[0].priceUsd),
          minMove: Math.pow(10, (checkDecimal(+this.chartData[0].priceUsd) * -1))
        }
      })

      const toolTipWidth = 80
      const toolTipHeight = 80
      const toolTipMargin = 15

      const toolTip = document.createElement('div')
      toolTip.className = 'floating-tooltip-2 w-max'
      this.$refs.chartjs.appendChild(toolTip)

      chart.subscribeCrosshairMove((param) => {
        if (param.point === undefined || !param.time || param.point.x < 0 || param.point.x > this.$refs.chartjs.clientWidth || param.point.y < 0 || param.point.y > this.$refs.chartjs.clientHeight) {
          toolTip.style.display = 'none'
        } else {
          toolTip.style.display = 'block'
          const price = param.seriesPrices.get(series)
          toolTip.innerHTML = '<div class="text-18 my-4 text-blackBlue flex-center-middle">' + '<p class="mr-5">' + this.$t('common.TMN') + '</p>' + this.$root.$options.filters.tomanSeparator(+price * +this.$store.getters['coins/buyDollarPrice']) + '</div><div class="text-blackBlue text-15 text-center">' + this.$t('common.USDT') + ' ' + this.$root.$options.filters.coinSeparator(+price) + '</div>'
          const coordinate = series.priceToCoordinate(price)
          let shiftedCoordinate = param.point.x - 50
          if (coordinate === null) {
            return
          }
          shiftedCoordinate = Math.max(0, Math.min(this.$refs.chartjs.clientWidth - toolTipWidth, shiftedCoordinate))
          const coordinateY = coordinate - toolTipHeight - toolTipMargin > 0 ? coordinate - toolTipHeight - toolTipMargin : Math.max(0, Math.min(this.$refs.chartjs.clientHeight - toolTipHeight - toolTipMargin, coordinate + toolTipMargin))
          toolTip.style.left = shiftedCoordinate + 'px'
          toolTip.style.top = coordinateY + 'px'
        }
      })
    }
  }
}
